import lodash from "lodash";
import { AppActions } from "../../action";
import {
  SET_MESSAGE,
  SET_LOADER,
  SHOW_ERROR_POPUP,
  SHOW_ALERT_POPUP,
  SET_MINI_LOADER,
  SHOW_NOT_FOUND_PAGE,
  HIDE_NOT_FOUND_PAGE,
  ALLOW_PERMISSION_FOR_PAGE,
  IS_SAFARI_AUTOFILL_VISISBLE,
  STORE_CURRENT_LOCATION,
  SHOW_SUCCESS_MESSAGE,
  SHOW_DISMISSIBLE_MESSAGE,
  EXPORT_BALLOTS_LIST,
  SET_GLOBAL_SEARCH_TEXT,
  SET_BALLOT_ADVANCE_SEARCH,
  SET_BALLOT_ADVANCE_FORM_DATA,
  SET_WI_ADVANCE_FORM_DATA,
  SET_BALLOT_DETAILS,
  SET_BALLOT_DETAIL_TAG,
  SET_SELECTED_BALLOT_STATUS,
  SET_QUICK_SEARCH_SELECTED_USER,
  SET_QUICK_SEARCH_SELECTED_LEVEL,
  SET_IS_USER_OFFICER,
  SET_WORK_ITEM_LIST,
  SET_DRAFTS_LIST,
  SET_WORK_ITEM_DETAIL,
  SET_COLLAB_API_FAILED,
  SET_MEMBER_LIST,
  SET_DTN_DETAIL,
  SET_NAVIGATION,
  SET_SELECTED_WORKITEM_STATUS,
  SET_SELECTED_WORKITEM_TYPE,
  SET_WI_SUPPRESS,
  SET_WI_EXTRA_FIELDS,
  SET_ALL_COMMITTEES,
  SET_PERMISSION_DATA,
  MANAGE_BALLOT_FLYOUT,
  SET_BALLOT_DOCUMENT_INFO,
  SET_BALLOT_TRACKING_LIST,
  SET_BALLOT_HISTORY_LIST,
  SET_SHOW_ALERT_MODAL_FOR_PENDINGPUBLICATION_BALLOT,
  SET_BALLOT_LIST,
  SET_ACTIVE_COMMITTEES,
  SET_DRAFT_DEPENDENCY
} from "../../action-type";
import { allowPermissionForAuth, filterPermissionUrl, getModulesAdditionalPrivilege } from "../../helpers/util-common";

import { PAGE_CONFIG } from "../../models/navigation.models";
import { setBallotAdvanceSearch } from "../../common.actions";

const initialState = {
  code: null,
  loading: false,
  miniLoader: false,
  showToastMessage: false,
  showSuccessToastMesage: false,
  showDismissibleToastMessage: false,
  showErrorPopup: false,
  errorMessages: [],
  isShowConfirmationPopup: false,
  currentRequest: "",
  statusList: [], // Moved this list in common as it is master data for renewal task module and will not change
  showAlertPopup: false,
  alertMessage: "",
  showNotFoundPage: false,
  userPermission: null,
  PAGE_CONFIG: PAGE_CONFIG,
  appUserList: [],
  isSafariAutoFillInfoVisible: false,
  isDocumentInfo: false,
  message: "",
  dismissibleMessage: "",
  uniqueRequestId: "",
  exportBallotList: false,
  globalSearchText: "",
  advanceBallotSearch: {},
  ballotAdvanceSearch: {},
  ballotDetailTag: 0,
  ballotDetailsData: {},
  selectedQuickSearchBallotStatus: "All",
  quickSearchSelectedUser: "",
  quickSearchSelectedLevel: [],
  ballotAdvanceSearchFormData: {},
  wiAdvanceSearchFormData: {},
  workItemList:{},
  workItemDetailData:{},
  draftsListData: {},
  ballotHistorylistData:{},
  isCollabAPIFailedPopup: false,
  collabAPIFailedMessage: null,
  dtnDetailData:{},
  navigationData:{},
  selectedQuickSearchWorkItemStatus:"All",
  selectedQuickSearchWorkItemType:"All",
  selectedQuickSearchWorkItemSuppressedValue:"Show all",
  WorkItemExtraFields:[],
  allCommittees:[],
  permissionData:{loading : true},
  ballotFlyoutData:{},
  ballotDocumentInfo: [],
  ballotTrackingList:[],
  ballotListData:[],
  allActiveCommittees:[],
  draftDependency:[]
};
type actionsType = AppActions;

// Validate All Permission [GET,PUT,DELETE,POST]
export const validateAllPermission = (request: any): any => {
  let pagePermission: any = {};
  let selectedUrl: any = lodash(request).get("Input") && lodash(request).get("Input");
  let groupUrl = lodash(request).get("groupInput") && lodash(request).get("groupInput");
  let additionalPermissionUrl = getModulesAdditionalPrivilege(selectedUrl);
  if (groupUrl && groupUrl.length > 0) {
    let groupFilter = groupUrl.filter((res: any) => res.componentElementOnPage.indexOf(selectedUrl.uniqueKey) > -1);
    if (groupFilter && groupFilter.length === 0 && additionalPermissionUrl && additionalPermissionUrl.length > 0) {
      // Push additional & current page If Component Element on Page get Empty
      groupFilter.push(selectedUrl, ...additionalPermissionUrl);
    }
    if (groupFilter && groupFilter.length > 0) {
      // Push additional & current page Url.
      groupFilter.push(selectedUrl, ...additionalPermissionUrl);
      groupFilter.map((modules: any) => {
        let isPageAuthorized =  filterPermissionUrl(modules, modules.oslMethod);
        let isAllow = allowPermissionForAuth(isPageAuthorized);
        if (isAllow) {
          pagePermission[modules.uniqueKey] = true;
        }
      });
    }
  }
  return pagePermission;
};
const getCurrentModule = (currentModuleData: any) => {
  if (currentModuleData && currentModuleData.Input) {
    return currentModuleData.Input.title;
  }

  return "";
};

const reducerCommon = (state: any = initialState, action: actionsType): any => {
  switch (action.type) {
    case SET_MESSAGE:
      return {
        ...state,
        code: action.code,
        showToastMessage: action.flag,
        message: action.message,
        uniqueRequestId: action.uniqueRequestId,
      };
    case SHOW_SUCCESS_MESSAGE:
      return {
        ...state,
        code: action.code,
        showSuccessToastMesage: action.flag,
        message: action.message,
      };
    case SHOW_DISMISSIBLE_MESSAGE:
      return {
        ...state,
        showDismissibleToastMessage: action.flag,
        dismissibleMessage: action.dismissibleMessage,
      };

    case SET_LOADER:
      return {
        ...state,
        loading: action.flag,
      };

    case SHOW_ERROR_POPUP:
      return {
        ...state,
        showErrorPopup: action.flag,
        errorMessages: action.data,
      };
    case SHOW_ALERT_POPUP:
      return {
        ...state,
        showAlertPopup: action.flag,
        alertMessage: action.data,
      };

    case SET_MINI_LOADER:
      return {
        ...state,
        miniLoader: action.flag,
      };

    case SHOW_NOT_FOUND_PAGE:
      return {
        ...state,
        showNotFoundPage: true,
      };
    case HIDE_NOT_FOUND_PAGE:
      return {
        ...state,
        showNotFoundPage: false,
      };
    case ALLOW_PERMISSION_FOR_PAGE:
      return {
        ...state,
        userPermission: validateAllPermission(action),
        PAGE_CONFIG: { ...PAGE_CONFIG },
        currentModuleTitle: getCurrentModule(action),
      };
    case IS_SAFARI_AUTOFILL_VISISBLE:
      return {
        ...state,
        isSafariAutoFillInfoVisible: action.flag,
      };
    case STORE_CURRENT_LOCATION:
      return {
        ...state,
        currentRequest: action.data,
      };
    case EXPORT_BALLOTS_LIST:
      return {
        ...state,
        exportBallotList: action.data,
      };
    case SET_GLOBAL_SEARCH_TEXT:
      return {
        ...state,
        globalSearchText: action.data,
      };
    case SET_BALLOT_ADVANCE_SEARCH:
      return {
        ...state,
        ballotAdvanceSearchFormData: action.data,
      };
    case SET_BALLOT_ADVANCE_FORM_DATA:
      return {
        ...state,
        ballotAdvanceSearchFormData: action.data,
      };
    case SET_WI_ADVANCE_FORM_DATA:
      return {
        ...state,
        wiAdvanceSearchFormData: action.data,
      };
    case SET_BALLOT_LIST:
    return {
      ...state,
      ballotListData: action.data,
    };
    case SET_BALLOT_DETAILS:
      return {
        ...state,
        ballotDetailsData: action.data,
      };
    case SET_BALLOT_DETAIL_TAG:
      return {
        ...state,
        ballotDetailTag: action.data,
      };
    case SET_SELECTED_BALLOT_STATUS:
      return {
        ...state,
        selectedQuickSearchBallotStatus: action.data,
      };
    case SET_QUICK_SEARCH_SELECTED_USER:
    return {
      ...state,
      quickSearchSelectedUser: action.data,
    };
    case SET_QUICK_SEARCH_SELECTED_LEVEL:
    return {
      ...state,
      quickSearchSelectedLevel: action.data,
    };
    case SET_SELECTED_WORKITEM_STATUS:
    return {
      ...state,
      selectedQuickSearchWorkItemStatus: action.data,
    };
    case SET_SELECTED_WORKITEM_TYPE:
    return {
      ...state,
      selectedQuickSearchWorkItemType: action.data,
    };
    case SET_WI_SUPPRESS:
      return {
        ...state,
        selectedQuickSearchWorkItemSuppressedValue: action.data,
      };
    case SET_WI_EXTRA_FIELDS:
    return {
      ...state,
      WorkItemExtraFields: action.data,
    };
    case SET_IS_USER_OFFICER:
    return {
      ...state,
      isUserOfficer: action.data,
    };
    case SET_WORK_ITEM_LIST:
    return {
      ...state,
      workItemList: action.data,
    };
    case SET_WORK_ITEM_DETAIL:
      return{
        ...state,
        workItemDetailData: action.data,
      }
    case SET_COLLAB_API_FAILED:
        return {
          ...state,
          isCollabAPIFailedPopup: !state.isCollabAPIFailedPopup,
          collabAPIFailedMessage: action.data
        }
    case SET_DRAFTS_LIST:
      return {
        ...state,
        draftsListData: action.data
      }
    case SET_BALLOT_HISTORY_LIST:
    return {
      ...state,
      ballotHistorylistData: action.data
    }
    case SET_MEMBER_LIST:
      return {
          ...state,
          technicalContactList: action.data
      }
      case SET_DTN_DETAIL:
        return{
          ...state,
          dtnDetailData: action.data,
        }
      case SET_NAVIGATION:
        return{
          ...state,
          navigationData: action.data,
        }
      case SET_ALL_COMMITTEES: 
        return {
         ...state,
          allCommittees: action.data || []
        }
        case SET_PERMISSION_DATA: 
        return {
         ...state,
          permissionData: action.data || []
        }
        case MANAGE_BALLOT_FLYOUT:
          return {
            ...state,
            ballotFlyoutData: action.data || []
           }
        case SET_BALLOT_DOCUMENT_INFO: 
          return {
          ...state,
            ballotDocumentInfo: action.data || []
          }
        case SET_BALLOT_TRACKING_LIST:
          return{
            ...state,
            ballotTrackingList: action.data || []
          }
        case SET_SHOW_ALERT_MODAL_FOR_PENDINGPUBLICATION_BALLOT:
          return {
            ...state,
            showAlertModalForPendingPublicationBallot: action.data || 0
          }  
        case SET_ACTIVE_COMMITTEES: 
        return {
         ...state,
          allActiveCommittees: action.data || []
        }
        case SET_DRAFT_DEPENDENCY: 
        return {
         ...state,
          draftDependency: action.data || []
        }
    default:
      return state;
  }
};

export default reducerCommon;
